import { useState,useEffect } from "react"
import { useProject } from "../Providers"

import style from "./controlPanel.module.scss"
import ControlPanelMenu from "./ControlPanelMenu"
import MenuTexts from "./MenuTexts"

const ControlPanelTexts = () => {
	const { user, setting, setSetting } = useProject()
	const [state, setstate] = useState({
		bus: false,
		stoppath: false,
		stop: false,
		screen: false,
		sounds: false,
		texts:true,
		version:false,
	})

	// useEffect(() => {
	// 	if(setting && setting.buspath ) {
	// 		setstate({
	// 			...state,
	// 			bus: false,
	// 			stoppath: false,
	// 			stop: false,
	// 		})
	// 	}
	// }, [setting && setting.buspath? setting.buspath:null]);	

	const handleChange = (e) =>{
		setstate((prev) => {
			for (const key in prev) prev[key] = false
			return {
				...prev,
				[e.target.name]: !(e.target.value === "true" && true),
			}
		})

		setSetting({
			...setting,
			leftbar : e.target.name
		})
	}

	return (
		<div className={style.controlPanelOptions}>
			{user && (
				<>
					<div className={style.controlPanelBox}>
						<button
							className={style.controlPanelOption}
							name='texts'
							value={state.texts}
							onClick={handleChange}
						>
							Text
						</button>
						{state.texts && 
							<MenuTexts setting={setting} setSetting={setSetting}/>
						}
					</div>				
					{/* <div className={style.controlPanelBox}>
						<button
							className={style.controlPanelOption}
							name='bus'
							value={state.bus}
							onClick={handleChange}
						>
							버스노선
						</button>
						{state.bus && <ControlPanelMenu type='bus' />}
					</div>
					<div className={style.controlPanelBox}>
						<button
							className={style.controlPanelOption}
							name='stoppath'
							value={state.stoppath}
							onClick={handleChange}
						>
							정류소경로
						</button>
						{state.stoppath && (
							<ControlPanelMenu type='stoppath' />
							// <SetStopModal onClose={()=>{close()}} />
						)}
					</div>					
					<div className={style.controlPanelBox}>
						<button
							className={style.controlPanelOption}
							name='stop'
							value={state.stop}
							onClick={handleChange}
						>
							정류소
						</button>
						{state.stop && (
							<ControlPanelMenu type='stop' />
						)}
					</div>
					<div className={style.controlPanelBox}>
						<button
							className={style.controlPanelOption}
							name='sounds'
							value={state.sounds}
							onClick={handleChange}
						>
							음성
						</button>
						{state.sounds && <ControlPanelMenu type='sounds' />}
					</div>
					<div className={style.controlPanelBox}>
						<button
							className={style.controlPanelOption}
							name='screen'
							value={state.screen}
							onClick={handleChange}
						>
							이미지
						</button>
						{state.screen && (
							<ControlPanelMenu type='screen' />
						)}
					</div> */}
				</>
			)}
		</div>
	)
}

export default ControlPanelTexts
